import ReactPlayer from 'react-player';
import { encodeFileNameInUrl } from '../api/utils/util-func';
import Buttons from '../components/common/Buttons';
import { ProductContent } from '../constants/types';
import { ProductContentType } from '../enum';

interface RenderContentProps {
  contents: ProductContent[];
  productName: string;
  productSubType?: string;
  imageAltPrefix?: string;
}

/**
 *어드민의 상품관리로 등록한 상품,코스,부스트업 상세페이지콘텐츠를 렌더링하는 함수
 * @param contents 상품,코스,부스트업상품의 상세페이지콘텐츠배열 (contents[])
 * @returns 정렬해서 렌더링
 */
export const renderDetailContents = ({
  contents,
  productName,
  productSubType,
  imageAltPrefix = '',
}: RenderContentProps) => {
  return contents
    .sort((a, b) => {
      const idxA = a.order_idx ?? 0;
      const idxB = b.order_idx ?? 0;
      return idxA - idxB;
    })
    .map((content: ProductContent) => {
      // 젭스톤 화상영어일때만
      if (productSubType === 'LEARN_ON_PHONE') {
        return (
          <a
            key={`${content.id}-${content.order_idx}`}
            href="https://www.jebsphone.com/"
            className="cursor-pointer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={encodeFileNameInUrl(content.file.access_url)}
              alt={`${productName} ${imageAltPrefix} 이미지`}
              className="w-full"
            />
          </a>
        );
      }

      switch (content.type) {
        case ProductContentType.VIDEO:
          return (
            <div key={`${content.id}-${content.order_idx}`} className="aspect-video overflow-hidden">
              <ReactPlayer
                url={content.video_url}
                width="100%"
                height="100%"
                controls
              />
            </div>
          );
        case ProductContentType.IMAGE:
          return (
            <img
              key={`${content.id}-${content.order_idx}`}
              src={encodeFileNameInUrl(content.file.access_url)}
              alt={`${productName} ${imageAltPrefix} 이미지`}
              className="w-full"
            />
          );
        case ProductContentType.URL:
          return (
            <div key={`${content.id}-${content.order_idx}`} className="mx-auto my-5 w-fit">
              <Buttons
                type="filled"
                color="purple5"
                onClick={() => {
                  window.open(content.url_link, '_blank');
                }}
              >
                {content.url_label}
              </Buttons>
            </div>
          );
        default:
          return null;
      }
    });
};
export default renderDetailContents;
